import { render, staticRenderFns } from "./AddVehicles.vue?vue&type=template&id=a2116728&scoped=true"
import script from "./AddVehicles.vue?vue&type=script&lang=js"
export * from "./AddVehicles.vue?vue&type=script&lang=js"
import style0 from "./AddVehicles.vue?vue&type=style&index=0&id=a2116728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2116728",
  null
  
)

export default component.exports